import { Breakpoints, Container, ContainerGutter, ContainerPadding, CTA, Layout, styled, Text, TextAlignment, ThemeProvider, TokenTextAppearance } from '@volkswagen-onehub/components-core';
import React from 'react';
import { ScreenController, TriggerProps, useFaContent, useTransformToHtml } from 'src/feature-app';
import { useDispatch } from 'react-redux';
import { TheOriginalsForm } from 'src/forms/FormsAdhoc/TheOriginals2025';

const Content = styled.div`
	overflow: hidden;
	display: flex;
	justify-content: center;
	align-items: center;
	background: radial-gradient(circle at bottom, #00437a 0%, #001e50 100%);

	& > div {
		width: 100%;
	}
`;

export function TheOriginals2025Trigger(props: TriggerProps) {
	const { setSelectedJourney, setCTALabel } = props;
	const dispatch = useDispatch();
	const faContent = useFaContent();

	const fullScreen = false;

	const alternativeHeadline = (faContent?.headline ? useTransformToHtml(faContent.headline) : useTransformToHtml('<b>¡Inscríbete en la 21ª edición de The Originals Fest!</b>'));

	const alternativeBodyCopy = (faContent?.bodycopy ? useTransformToHtml(faContent.bodycopy) : useTransformToHtml('Este año celebraremos la 21ª edición y nos encanta que quieras vivirla con nosotros. ¡Empecemos!'));

	const getCtaLabel = () => (faContent?.cta ? faContent.cta : 'Empezar');


	if(fullScreen) {
	return <ScreenController
		selectedJourney={<TheOriginalsForm fullScreen={fullScreen} introTitle={<div dangerouslySetInnerHTML={alternativeHeadline} />} introCopy={<div dangerouslySetInnerHTML={alternativeBodyCopy} />} />}
		closeLayerCallback={close}
		handleAreYouSureLayer={() => null}
		notALayer={true}
		formType='inPage'
	/>;
	}
	else {
		return (
			<ThemeProvider theme="inverted">
				<Content>
					<Layout
						appearance={{
							[Breakpoints.default]: [
								{ name: '.', columns: 2 },
								{ name: 'a', columns: 20 },
								{ name: '.', columns: 2 },
							],
							[Breakpoints.b960]: [
								{ name: '.', columns: 3 },
								{ name: 'a', columns: 18 },
								{ name: '.', columns: 3 },
							],
							[Breakpoints.b1280]: [
								{ name: '.', columns: 4 },
								{ name: 'a', columns: 16 },
								{ name: '.', columns: 4 },
							],
							[Breakpoints.b1600]: [
								{ name: '.', columns: 1 },
								{ name: 'a', columns: 22 },
								{ name: '.', columns: 1 },
							],
						}}
					>
						<Container wrap={'always'} padding={{ top: ContainerPadding.dynamic0250 }}>
							<Container wrap={'always'} gutter={ContainerGutter.dynamic0100}>
								<Text textAlign={TextAlignment.center} appearance={TokenTextAppearance.headline300}>
									<div dangerouslySetInnerHTML={alternativeHeadline} />
								</Text>

								<Text textAlign={TextAlignment.center} appearance={TokenTextAppearance.copy200}>
									<div dangerouslySetInnerHTML={alternativeBodyCopy} />
								</Text>
							</Container>
							<Container wrap={'always'} gutter={ContainerGutter.static400} padding={{ bottom: ContainerPadding.dynamic0250, top: ContainerPadding.dynamic0150 }}>
								<div style={{textAlign: 'center'}}>
										<CTA
											tag="button"
											onClick={() => {
												dispatch({ type: 'RESET_STATE' });
												setCTALabel(getCtaLabel());
												setSelectedJourney(<TheOriginalsForm fullScreen={fullScreen} />);
											}}
											stretchContent={{[Breakpoints.default]: true, [Breakpoints.b560]: false}}
										>
											{getCtaLabel()}
										</CTA>
								</div>
							</Container>
						</Container>
					</Layout>
				</Content>
			</ThemeProvider>
		);
	}
}
